import { getUserPermissions } from "directus/src/operations";

export async function fetchUserPermissions() {
  try {
    const response = await getUserPermissions();
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
